import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import ctaImage1 from '@/assets/faqs/cta-image-1.jpg';
import ctaImage2 from '@/assets/faqs/cta-image-2.jpg';

const FAQsCTASection: React.FC = () => {
  return (
    <section className="bg-[#fafafb] py-16 lg:py-20">
      <div className="max-w-container-lg mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-[#ffad0a] rounded-[20px] p-8 lg:p-16 relative overflow-hidden"
        >
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            {/* Left Side - Text Content */}
            <div className="relative z-10">
              <h2 className="font-open-sans font-bold text-3xl lg:text-[32px] leading-[48px] text-white mb-4">
                Can't find your answer?
              </h2>
              <p className="font-open-sans text-base leading-[26px] text-white mb-8 max-w-md">
                Our support team is here to help with any questions or issues you might have. Reach out to us and we'll get back to you as soon as possible.
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 bg-brand-blue text-white px-6 py-3 rounded-lg font-manrope text-base hover:bg-brand-blue-700 transition-colors shadow-lg"
              >
                Contact us
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                  />
                </svg>
              </Link>
            </div>

            {/* Right Side - Decorative Images */}
            <div className="relative hidden lg:block">
              <div className="relative">
                <motion.div
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  className="absolute -top-5 right-0 w-[250px] h-[285px] rounded-lg overflow-hidden z-10"
                >
                  <img
                    src={ctaImage2}
                    alt="Support illustration"
                    className="w-full h-full object-cover"
                  />
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.3 }}
                  className="absolute -top-3 right-4 w-[242px] h-[279px] rounded-t-[28px] overflow-hidden"
                >
                  <img
                    src={ctaImage1}
                    alt="Support illustration"
                    className="w-full h-full object-cover"
                  />
                </motion.div>
                
                {/* Decorative Icons */}
                <div className="absolute top-12 left-0 bg-[#3a5f5a] rounded-full w-[52px] h-[52px] flex items-center justify-center">
                  <svg
                    className="w-6 h-6 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <div className="absolute top-3 left-40 bg-brand-blue rounded-full w-[52px] h-[52px] flex items-center justify-center">
                  <svg
                    className="w-6 h-6 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQsCTASection;
